export default __webpack_public_path__ + "static/safe-996d23f21e0aa77e53f7725da286de9d.svg";